import { useEffect } from "react";
import { useI18nContext } from "@hopper-b2b/i18n";

// TODO: for now, redirect to external page.
export const TermsAndConditions = () => {
  const {
    brand: { urls },
  } = useI18nContext();

  useEffect(() => {
    window.location.href = urls.termsAndConditions;
  }, [urls.termsAndConditions]);

  return null;
};
